const Text = ({ mainColor, ...props }) => (
  <g fill-rule="nonzero" fill={mainColor} {...props}>
    <path d="M.51.385h19.98v1H.51zM.51 4.007H15.79v1H.51zM.51 7.63h19.98v1H.51zM.51 11.252H15.79v1H.51zM.51 14.874h5.66v1H.51zM.51 18.497h19.093v1H.51zM.51 22.12h16.603v1H.51zM.51 25.742h17.753v1H.51z" />
  </g>
)

export default Text



// WEBPACK FOOTER //
// ./svg/Text.js